// removed by extract-text-webpack-plugin
module.exports = {"auditTemplateOverviewHeader":"AuditTemplateBlockOverviewHeader__auditTemplateOverviewHeader__124CO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockOverviewHeader/AuditTemplateBlockOverviewHeader.scss
// module id = 1626
// module chunks = 0